<mat-card class="width-gt-sm" data-cy="SatzungPage">
    <mat-card-header>
        <mat-card-title>Anmeldung/Satzung</mat-card-title>
    </mat-card-header>
    <mat-card-content>
            <p>
                Du bist ein leidenschaftlicher Paddler und möchtest auch zum Verein dazu gehören?<br />
                <br />
                Das geht ganz einfach: Anmeldeformular ausfüllen, ausdrucken und am besten persönlich bei einem
                Vorstandsmitglied abgeben.<br />
                <br />
                <a href="\assets\downloads\Aufnahmeantrag.pdf">Anmeldeformular (.pdf)</a><br />
                <br />
                <a href="\assets\downloads\Satzung_1995.pdf">Vereinssatzung (.pdf)</a><br />
                <br />
                <a href="\assets\downloads\Unbedenklichkeitserklaerung_Minderjährige.pdf">
                    Unbedenklichkeitserklaerung für Minderjährige (.pdf)
                </a>
                <br />
            </p>
            <p>Unsere Mitgliedsbeiträge pro Jahr gemäß Beschluss der JHV vom 14.03.2017</p>

        <div class="width-gt-md">
            <kkm-vereinsbeitraege />
        </div>
    </mat-card-content>
</mat-card>
